export default __webpack_public_path__ + "static/media/google_icon.e6226f71.svg";